import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = useState(7);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 941 FAQ: Answers to Common Payroll Tax Questions"
          description="Get answers to common Form 941 payroll tax questions. Learn about filing deadlines, corrections, and e-filing options with TaxZerone’s expert support."
          keywords=""
          canonical="faqs/form-941/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form 941</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 941
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 7004
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  <Grid size={12} sx={{ pt: '0 !important' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is Form 941, and who needs to file it?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          <Link
                            href="/resources/employment-tax/form-941-instructions/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Form 941
                          </Link>
                          , also known as the Employer&apos;s Quarterly Federal
                          Tax Return, is used to report payroll taxes to the
                          IRS. Employers who withhold federal income tax, Social
                          Security tax, and Medicare tax from their
                          employees&apos; wages are required to file 941 form
                          quarterly. This form helps employers reconcile the
                          amount of taxes withheld from employee paychecks and
                          the employer&apos;s share of Social Security and
                          Medicare taxes.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Can I file Form 941 electronically?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box component="div" itemProp="text">
                          <Typography variant="body1">
                            Yes, the IRS encourages employers to{' '}
                            <Link
                              href="/employment-tax/e-file-irs-form-941/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              file Form 941
                            </Link>{' '}
                            electronically. E-filing offers several benefits,
                            including faster processing, reduced errors, and
                            instant confirmation of receipt by the IRS. Our
                            platform provides a convenient and secure way to
                            electronically file 941 form, ensuring a seamless
                            tax filing experience.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What happens if I miss the deadline for filing IRS Form
                        941?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography variant="body1">
                            Failing to file IRS Form 941 by the deadline can
                            result in penalties from the IRS. The penalty amount
                            is based on the number of days the return is late
                            and the size of the employer&apos;s business.
                            Additionally, if you fail to pay the taxes owed by
                            the due date, you may also be subject to penalties
                            and interest on the unpaid amount. It&apos;s crucial
                            to file and pay on time to avoid unnecessary
                            penalties and interest charges.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How to sign when filing 941 electronically?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography component="div" sx={{ mb: 0 }}>
                            To sign Form 941 electronically, follow these
                            methods:
                          </Typography>
                          <ul>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Practitioner PIN Signature Method—Form 8879
                              </span>
                              <ul>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Taxpayer Selection of PIN:
                                  </span>{' '}
                                  The ERO contacts the taxpayer to choose a
                                  5-digit PIN. The taxpayer can authorize the
                                  ERO to input the PIN or enter it directly.
                                </li>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Completion of Form 8879-EMP:
                                  </span>{' '}
                                  The ERO completes the form with their 11-digit
                                  PIN (6-digit EFIN + 5 numeric characters) and
                                  the taxpayer’s 5-digit PIN. The ERO must sign
                                  the form.
                                </li>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Retention and Transmission:
                                  </span>{' '}
                                  Retain the signed form for three years,
                                  provide a copy to the taxpayer, and do not
                                  send it to the IRS.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Scanned{' '}
                                <Link
                                  href="/resources/employment-tax/form-941-signature-options/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  Form 8453 Signature Method
                                </Link>
                              </span>
                              <ul>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Signing Form 8453-EMP:
                                  </span>{' '}
                                  The entity&apos;s authorized signer signs Form
                                  8453-EMP.
                                </li>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Scanning and Attaching:
                                  </span>{' '}
                                  Scan the signed form and attach it as a PDF to
                                  the electronic return.
                                </li>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Retention:
                                  </span>{' '}
                                  Retain a copy of the signed form, but do not
                                  mail it to the IRS.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Reporting Agent PIN Signature Method—Form 8655
                              </span>
                              <ul>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Obtaining a Reporting Agent PIN:
                                  </span>{' '}
                                  Apply for a five-digit PIN through the IRS
                                  e-File application process.
                                </li>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Submitting Form 8655:
                                  </span>{' '}
                                  Authorize the Reporting Agent to sign the
                                  client’s return with the five-digit PIN.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                <Link
                                  href="/employment-tax/e-file-irs-form-94x-pin-request/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  94x Online e-Filer Signature Method
                                </Link>{' '}
                                (IRS Authorized Signer)
                              </span>
                              <ul>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Registration:
                                  </span>{' '}
                                  The Owner or Principal Officer submits a 94x
                                  Online Signature PIN Registration Application
                                  using IRS Approved E-FIling software at least
                                  45 days before the return due date.
                                </li>
                                <li>
                                  <span style={{ fontWeight: 600 }}>
                                    Receiving the PIN:
                                  </span>{' '}
                                  The IRS issues a 10-digit 94x Online Signature
                                  PIN for signing 94x family tax returns through
                                  approved software.
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is Schedule B on Form 941?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography component="div" sx={{ mb: 2 }}>
                            Schedule B on Form 941 is used by employers who must
                            deposit federal employment taxes on a semiweekly
                            basis. As an employer, federal law requires you to
                            withhold certain taxes from your employees&apos;
                            pay, including federal income tax, social security
                            tax, Medicare tax, and Additional Medicare Tax for
                            wages over $200,000 per year. These withholdings are
                            credited toward your employees&apos; tax
                            liabilities.
                          </Typography>
                          <Typography component="div" sx={{ mb: 2 }}>
                            Additionally, employers must pay the employer share
                            of social security and Medicare taxes, which are not
                            withheld from employees&apos; pay.
                          </Typography>
                          <Typography component="div" sx={{ mb: 0 }}>
                            When filling out{' '}
                            <Link
                              href="/resources/employment-tax/form-941-schedule-b-filing-requirements/"
                              sx={{ color: '#0202ff' }}
                            >
                              Schedule B
                            </Link>
                            , list your tax liability for each day based on the
                            dates wages were paid. This liability includes:
                          </Typography>
                          <ul>
                            <li>
                              Federal income tax withheld from employees&apos;
                              pay
                            </li>
                            <li>
                              Both the employer and employee share of social
                              security and Medicare taxes
                            </li>
                          </ul>
                          <Typography component="div" sx={{ mb: 0 }}>
                            Do not use Schedule B to show federal tax deposits,
                            as the IRS receives this information through
                            electronic funds transfers.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                        id="form4868"
                      >
                        How to Claim Payroll Tax Credit for Increasing Research
                        Activities?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography component="div" sx={{ mb: 0 }}>
                            To claim the payroll tax credit for increasing
                            research activities, follow these steps while filing
                            your 2025 Form 941:
                          </Typography>
                          <ol>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Eligibility Check:
                              </span>
                              <ul>
                                <li>
                                  Ensure your small business qualifies for the
                                  research activities credit. Typically, this
                                  applies to businesses with gross receipts of
                                  less than $5 million for the current year and
                                  no gross receipts for any tax year before the
                                  five-year period ending with the current tax
                                  year.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Calculate the Research Credit:
                              </span>
                              <ul>
                                <li>
                                  Determine your research credit based on
                                  qualifying research expenses. The IRS provides
                                  guidelines for calculating this credit.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Complete Form 8974:
                              </span>
                              <ul>
                                <li>
                                  Fill out{' '}
                                  <Link
                                    href="/resources/employment-tax/form-8974-instructions/"
                                    sx={{ color: '#0202ff' }}
                                  >
                                    Form 8974
                                  </Link>
                                  , &quot;Qualified Small Business Payroll Tax
                                  Credit for Increasing Research
                                  Activities.&quot; This form determines the
                                  portion of your research credit that can be
                                  applied against your payroll tax liability.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Filing with TaxZerone:
                              </span>
                              <ul>
                                <li>
                                  Use TaxZerone to complete your 2025 Form 941.
                                  TaxZerone simplifies the process by guiding
                                  you through each step.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Attach Form 8974:
                              </span>
                              <ul>
                                <li>
                                  Ensure that Form 8974 is properly completed
                                  and attached to your Form 941. In TaxZerone,
                                  you will be prompted to attach Form 8974
                                  during the filing process.
                                </li>
                              </ul>
                            </li>
                            <li style={{ marginBottom: 12 }}>
                              <span style={{ fontWeight: 600 }}>
                                Enter the Credit on Form 941:
                              </span>
                              <ul>
                                <li>
                                  On Form 941, enter the amount from Form 8974
                                  on Line 11 (credit for qualified small
                                  business payroll tax credit for increasing
                                  research activities).
                                </li>
                              </ul>
                            </li>
                          </ol>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                        id="form941"
                      >
                        When are Form 941 due?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography component="div" sx={{ mb: 0 }}>
                            Form 941 irs must be filed quarterly. The due dates
                            are as follows:
                          </Typography>
                          <ul>
                            <li>
                              {' '}
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                1st Quarter (Jan-Mar)
                              </span>{' '}
                              Due by{' '}
                              <span style={{ fontWeight: 600 }}> April 30</span>
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                2nd Quarter (Apr-Jun):
                              </span>{' '}
                              Due by{' '}
                              <span style={{ fontWeight: 600 }}>
                                July 31
                              </span>{' '}
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                3rd Quarter (Jul-Sep):
                              </span>{' '}
                              Due by{' '}
                              <span style={{ fontWeight: 600 }}>
                                November 2
                              </span>{' '}
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                4th Quarter (Oct-Dec):
                              </span>{' '}
                              Due by{' '}
                              <span style={{ fontWeight: 600 }}>
                                February 1
                              </span>
                            </li>
                          </ul>
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{
                              mb: 2,
                              fontSize: 13,
                              borderLeft: '3px solid rgb(102, 60, 0)',
                            }}
                          >
                            <b> Note:</b> If the deadline falls on a weekend or
                            federal holiday, the filing deadline is extended to
                            the next business day
                          </Alert>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
